import { IntegrationMaintenanceConfig } from './types';

export function formatIntegrationMaintenanceConfig(
  raw: any
): IntegrationMaintenanceConfig {
  return {
    // Default to true for Zapier to maintain the integration on the partner’s behalf.
    // This mirrors the default behavior on the backend.
    allowInternalMaintenance: raw?.allow_internal_maintenance ?? true,
    // Default to false because only the technical contact for the integration can change this setting.
    // This mirrors the default behavior on the backend.
    isEditable: raw?.is_editable ?? false,
  };
}
